window.jQuery = window.$ = require('jquery')

require('popper.js/dist/umd/popper.min.js')
require('bootstrap/js/dist/util.js')
require('bootstrap/js/dist/modal.js')
require('bootstrap/js/dist/dropdown.js')
require('bootstrap/js/dist/collapse.js')
require('bootstrap/js/dist/tooltip.js')

import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

import { SessionKit } from "@wharfkit/session"
import { WebRenderer } from "@wharfkit/web-renderer"
import { WalletPluginAnchor } from "@wharfkit/wallet-plugin-anchor"
import { WalletPluginWombat } from "@wharfkit/wallet-plugin-wombat"
import { WalletPluginCloudWallet } from "@wharfkit/wallet-plugin-cloudwallet"

const webRenderer = new WebRenderer()

const sessionKit = new SessionKit({
  appName: "PFP Wizard",
  chains: [
    {
      id: "1064487b3cd1a897ce03ae5b6a865651747e2e152090f99c1d19d44e01aea5a4",
      url: "https://wax.greymass.com",
    },
  ],
  ui: webRenderer,
  walletPlugins: [new WalletPluginCloudWallet(), new WalletPluginAnchor(), new WalletPluginWombat()],
})

let session
let account

// tries to restore session, called when document is loaded
async function restoreSession() {
    session = await sessionKit.restore()
    // If the session was defined, set the UI to logged in
    if (session) {
        didLogin()
        refreshAccount()
    }
}

// login and store session if successful
function login() {
    return sessionKit.login().then(async (result) => {
        session = result.session
        didLogin()
        await refreshAccount()
    })
}

function refreshAccount() {
    return session.client.v1.chain.get_account(session.actor).then((result) => {
        account = result
        var balance = account.core_liquid_balance ? account.core_liquid_balance : '0.0000'
        $('#account-balance').text(parseFloat(balance).toFixed(2) + ' WAX');
    })
}

async function logout() {
    // Logout all sessions
    await sessionKit.logout()
    $(document.body).removeClass('logged-in');
    session = undefined
    account = undefined
}


// called when session was restored or created
function didLogin() {
  $('#btn-account').attr("href", `/pfp/profile/${session.actor}`);
  $('#btn-explorer').attr("href", `https://waxblock.io/account/${session.actor}`);
  $('#btn-account-filter').attr("href", `?owner=${session.actor}`);
  $('#btn-account-label').text(session.actor);
  if(!$('#gridWallets').val()) { $('#gridWallets').val(session.actor) };
  $(document.body).addClass('logged-in');
}

// buy an item
function buy(asset_id, listing_price, sale_id, amount, median) {
  if (session == undefined) {
    login()
  } else {
    const actions = [
      {
        account: "atomicmarket",
        name: "assertsale",
        authorization: [session.permissionLevel],
        data: {
          asset_ids_to_assert: [asset_id],
          listing_price_to_assert: listing_price,
          sale_id: sale_id,
          settlement_symbol_to_assert: "8,WAX",
        },
      },
      {
        account: "eosio.token",
        name: "transfer",
        authorization: [session.permissionLevel],
        data: {
          from: session.actor,
          to: "atomicmarket",
          quantity: amount,
          memo: "deposit",
        },
      },
      {
        account: "atomicmarket",
        name: "purchasesale",
        authorization: [session.permissionLevel],
        data: {
          buyer: session.actor,
          intended_delphi_median: median,
          sale_id: sale_id,
          taker_marketplace: "pfpwizardmkt",
        },
      },
    ]

    session.transact({actions}).then((result) => {
      if (result.response) {
        $('.sale-wrapper').html('<p class="txt"><strong class="green">Success</strong> <a href="https://waxblock.io/transaction/' + result.resolved.transaction.id + '" target="_blank">View on Explorer</a></p>')
      } else {
        $('.sale-wrapper').append('<p class="txt txt--small"><strong class="red">Something went wrong, try again</strong></p>')
      }
    }).catch((e) => {
      console.log('caught', e)
    })
  }
}


setInterval(() => {
  if (session) {
    refreshAccount()
  }
}, 3000)


window.onload = restoreSession();

$('#btn-login').click(function(e){
  e.preventDefault()
  login()
});

$('#btn-logout').click(function(e){
  e.preventDefault()
  logout()
});

$(document).on("click", '#btn-buy', function(e){
  e.preventDefault()
  buy(parseInt($(this).data("asset")), $(this).data("price"), parseInt($(this).data("sale")), $(this).data("amount"), parseInt($(this).data("median")))
});





$('[data-toggle="modal"][data-remote]').on('click', function(){
  $($(this).data("target")+' .modal-body').load($(this).data("remote")+" #main-info");
});
$('#modal-detail').on('shown.bs.modal', function (e) {
  setInterval(() => {
    $(this).find('[data-toggle="tooltip"]').tooltip();
  }, 10)
})
$('#modal-detail').on('hidden.bs.modal', function (e) {
  $(this).find('.modal-body').empty();
})




function collectionPopulate(){
  var vals = $('.grid-collection:checked').map(function() {
    return this.value;
  }).get().join(',');
  $('#gridCollections').val(vals);
}

$('form').submit(function() {
  $(this).find("button[type='submit']").prop('disabled',true);
});

$('.grid-collection').on('change', function() {
  collectionPopulate()
}).change();

$('.grid-collection-all').on('change', function() {
  if ($(this).is(":checked")) {
    $('.grid-collection-panel').removeClass('show');
  } else {
    $('.grid-collection-panel').addClass('show');
  }
}).change();


$(function () {
  $('[data-toggle="tooltip"]').tooltip()
})


$(document).on("click", '.is-ajax', function(e){
  e.preventDefault();
  var $this = $(this);
  $.ajax({
    url: $this.attr('href')
  })
  .done(function() {
    $(document.body).toggleClass('has-rarity');
    var $img = $this.find('img');
    if ($this.attr('href').slice(-1) == 1) {
      $this.attr('href', $this.attr('href').slice(0, -1) + '0');
      $this.html('Hide Rarity').prepend($img);
    } else {
      $this.attr('href', $this.attr('href').slice(0, -1) + '1');
      $this.html('Show Rarity').prepend($img);
    }
  });
});

$('#set-filter-owner').click(function(e){
  e.preventDefault()
  $(this).parent('.filter-action').find('input').val(session.actor);
});

$('[data-toggle-class]').on('click', function(e){
  e.preventDefault();
  var $this = $(this),
      toggleClass = $this.attr('data-toggle-class');
  if ($this.closest('[data-toggle-class-target]').length) {
    $this.closest('[data-toggle-class-target]').toggleClass(toggleClass);
  } else {
    $(document.body).toggleClass(toggleClass);
  }
});




$(document).on('input', '#sweep-range', function() {
  var $this = $(this),
      items = $this.val(),
      amount = 0,
      usd = 0,
      wax_to_usd = parseFloat($this.closest('.sweep').attr('data-wax-usd'))

  $('#sweep-items').html(items);
  $('#sweep-amount').html(amount);
  $('#sweep-usd').html(usd);

  $('.rank-box').each(function(index) {
    var $this = $(this);
    if (index < items) {
      $this.addClass('is-sweep');
      amount = amount + parseFloat($this.attr('data-amount').split(" ")[0]);
      $('#sweep-amount').html(amount.toFixed(2));
      $('#sweep-usd').html((amount * wax_to_usd).toFixed(2));
    } else {
      $this.removeClass('is-sweep');
    }
  })
});


function sweepBuy() {
  if (session == undefined) {
    login()
  } else {
    var actions = []

    $('.rank-box.is-sweep').each(function() {
      var $this = $(this),
          asset_id = $this.attr('data-asset'),
          listing_price = $this.attr('data-price'),
          sale_id = $this.attr('data-sale'),
          amount = $this.attr('data-amount'),
          median = $this.attr('data-median');

      actions.push(
        {
          account: "atomicmarket",
          name: "assertsale",
          authorization: [session.permissionLevel],
          data: {
            asset_ids_to_assert: [asset_id],
            listing_price_to_assert: listing_price,
            sale_id: sale_id,
            settlement_symbol_to_assert: "8,WAX",
          },
        },
        {
          account: "eosio.token",
          name: "transfer",
          authorization: [session.permissionLevel],
          data: {
            from: session.actor,
            to: "atomicmarket",
            quantity: amount,
            memo: "deposit",
          },
        },
        {
          account: "atomicmarket",
          name: "purchasesale",
          authorization: [session.permissionLevel],
          data: {
            buyer: session.actor,
            intended_delphi_median: median,
            sale_id: sale_id,
            taker_marketplace: "pfpwizardmkt",
          },
        }
      );
    });

    session.transact({actions}).then((result) => {
      if (result.response) {
        $('.sweep').append('<p class="txt"><strong class="green">Success</strong> <a href="https://waxblock.io/transaction/' + result.resolved.transaction.id + '" target="_blank">View on Explorer</a></p>')
        $('#sweep-items').html('0');
        $('#sweep-amount').html('0');
        $('#sweep-usd').html('0');
        $('#sweep-range').val(0);
        $('.rank-box.is-sweep').closest('.col').remove();
      } else {
        $('.sweep').append('<p class="txt txt--small"><strong class="red">Something went wrong, try again</strong></p>')
      }
      setTimeout(function() {
        $('.sweep .txt').remove();
      }, 4000);
    }).catch((e) => {
      console.log('caught', e)
    })
  }
}


$(document).on("click", '#sweep-buy', function(e){
  e.preventDefault()
  sweepBuy()
});




var initCarousel = function(){
  $('.bundle')
    .not('.swiper-initialized')
    .each(function() {
      var $this = $(this),
          $carouselWrapper = $this.closest('.rank-box'),
          $rank = $carouselWrapper.find('.rank-box-rank'),
          $prev = $carouselWrapper.find('.bundle-btn--prev'),
          $next = $carouselWrapper.find('.bundle-btn--next');

      var swiper = new Swiper($this[0], {
        modules: [Navigation],
        threshold: 10,
        loop: true,
        navigation: {
          nextEl: $next[0],
          prevEl: $prev[0],
        },
        spaceBetween: 0,
        slidesPerView: 1
      });
      swiper.on('slideChange', function () {
        var $active = $(this.slides[this.activeIndex]);
        $rank.text($active.attr('data-rank'));
      });
    });
};
$(document).ready(function(){
  initCarousel();
});






function confetti() {
  $.each($(".wuf--confetti"), function(){
    var confetticount = ($(this).width()/50)*10;
    for(var i = 0; i <= confetticount; i++) {
      $(this).append('<span class="particle c' + $.rnd(1,2) + '" style="top:' + $.rnd(10,50) + '%; left:' + $.rnd(0,100) + '%;width:' + $.rnd(6,8) + 'px; height:' + $.rnd(3,4) + 'px;animation-delay: ' + ($.rnd(0,30)/10) + 's;"></span>');
    }
  });
};
jQuery.rnd = function(m,n) {
  m = parseInt(m);
  n = parseInt(n);
  return Math.floor( Math.random() * (n - m + 1) ) + m;
}
confetti();
